export default __webpack_public_path__ + "static/media/agent-list-avatar-placeholder.5c66d210.svg";